// src/components/common/TipCard.tsx
import React from 'react';
import SparkCard from './SparkCard';

interface TipCardProps {
  /** One‑line tip to show under the “Tip” label */
  message: string;
}

/**
 * Glowing “Tip” card with white text, text‑wrapping, and extra bottom spacing
 */
const TipCard: React.FC<TipCardProps> = ({ message }) => (
  <SparkCard
    className="
      px-2
      border border-white/20 bg-white/5 backdrop-blur-sm
      text-white text-center
      mt-0 mb-4   /* 1 rem gap below the tip card */
      p-0
    "
    style={{ padding: '0' }}
  >
    {/* 💡 Tip header */}
    <div className="flex flex-col items-center p-1" style={{ padding: '2px 0' }}>
      <div className="flex items-center gap-1">
        <span
          className="text-lg leading-tight"
          style={{ color: 'white', fontSize: '14px' }}
        >
          💡
        </span>
        <span
          className="font-bold text-xl leading-tight"
          style={{ color: 'white', fontSize: '16px' }}
        >
          Tip
        </span>
      </div>

      {/* Wrapped tip text */}
      <p
        className="mt-0 text-xs leading-tight break-words"
        style={{ color: 'white', maxWidth: '200px', margin: '0 auto', fontSize: '11px' }}
      >
        {message}
      </p>
    </div>
  </SparkCard>
);

export default TipCard;
